(function ($) {

  //
  //  Gutenberg (container)
  //

  const $sphere_block = jQuery('.block-sphere');
  if ($sphere_block.length) {

    var done = false;

    // Elements
    const $sphere_video = $sphere_block.find('video');
    const $sphere_image = $sphere_block.find('.sphere-foreground-image-wrapper');
    const $sphere_panel = $sphere_block.find('.sphere-panel');
    const video = $sphere_video.get(0);

    // Animation
    const timeline = gsap.timeline({ 'paused': true });

    timeline.to($sphere_video.get(0), { // element
      transform: 'translateY(30vh)', // effect
      duration: 3 // duur in sec.
    }, 0); // start in sec.

    timeline.to($sphere_image.get(0), {
      transform: 'scale(1)',
      duration: 3.5
    }, 0);

    // ScrollTrigger
    ScrollTrigger.create({
      trigger: $sphere_block.get(0),
      start: "top top+=33%",
      onEnter: () => {
        if (done) return;
        done = true;
        video.currentTime = 0;
        video.play();
        timeline.restart();
      }
    });

    // Buttons > menu interaction
    const $sphere_dots = jQuery('.block-sphere [data-menu-slug]');
    const $sphere_menu_items = jQuery('.block-sphere [data-slug]');

    $sphere_dots.on('mouseenter', function (e) {
      let slug = $(this).attr('data-menu-slug');
      $sphere_panel.find('[data-slug=' + slug + ']').addClass('active');
    });

    $sphere_dots.on('mouseleave', function (e) {
      let slug = $(this).attr('data-menu-slug');
      $sphere_panel.find('[data-slug=' + slug + ']').removeClass('active');
    });

    $sphere_dots.on('click', function (e) {
      let slug = $(this).attr('data-menu-slug');
      let a = $sphere_panel.find('[data-slug=' + slug + '].link > a');
      if (a.length) a.get(0).click();
    });

    // Menu > buttons interaction
    $sphere_menu_items.on('mouseenter', function (e) {
      let slug = $(this).attr('data-slug');
      $sphere_block.find('[data-menu-slug=' + slug + ']').addClass('active');
    });

    $sphere_menu_items.on('mouseleave', function (e) {
      let slug = $(this).attr('data-slug');
      $sphere_block.find('[data-menu-slug=' + slug + ']').removeClass('active');
    });

  }

  //
  //  Overlay (container)
  //

  const $sphere_overlay = jQuery('.sphere-overlay');
  if ($sphere_overlay.length) {

    // Elements
    const $sphere_close_button = jQuery('.sphere-close-button');
    const $sphere_panel = $sphere_overlay.find('.sphere-panel');
    const $sphere_video = $sphere_overlay.find('video');
    const $sphere_image = $sphere_overlay.find('.sphere-foreground-image-wrapper');
    const video = $sphere_video.get(0);
    const $body = jQuery('body');

    // Animation
    const timeline = gsap.timeline({ 'paused': true });

    timeline.to($sphere_video.get(0), { // element
      transform: 'translateY(30vh)', // effect
      duration: 1 // duur in sec.
    }, 0); // start in sec.

    timeline.to($sphere_image.get(0), {
      transform: 'scale(1)',
      duration: 1.25
    }, 0);

    timeline.to($sphere_close_button.get(0), {
      transform: 'translateX(0)',
      duration: .250
    }, 1);

    timeline.to($sphere_panel.get(0), {
      transform: 'translateX(0)',
      duration: .250
    }, 1);

    // Buttons open/close
    const $sphere_button = jQuery('.sphere-button');
    $sphere_button.on('click', function (e) {
      $body.addClass('sphere-overlay-showing');
      $('[data-panel-close="NavigationPanel"]').click();
      $sphere_overlay.fadeIn(50);
      video.currentTime = 0;
      video.play();
      timeline.restart();
      e.preventDefault();
      e.stopPropagation();
    });

    $sphere_close_button.on('click', function (e) {
      $sphere_overlay.fadeOut(50);
      $body.removeClass('sphere-overlay-showing');
    });

    $sphere_overlay.on('click', function (e) {
      e.stopPropagation();
    });

    $sphere_overlay.bind('scroll wheel mousewheel DOMMouseScroll', function (e) {
      e.preventDefault();
      e.stopPropagation();
    });

    // Buttons > menu interaction
    const $sphere_dots = jQuery('.sphere-overlay [data-menu-slug]');
    const $sphere_menu_items = jQuery('.sphere-overlay [data-slug]');

    $sphere_dots.on('mouseenter', function (e) {
      let slug = $(this).attr('data-menu-slug');
      $sphere_panel.find('[data-slug=' + slug + ']').addClass('active');
    });

    $sphere_dots.on('mouseleave', function (e) {
      let slug = $(this).attr('data-menu-slug');
      $sphere_panel.find('[data-slug=' + slug + ']').removeClass('active');
    });

    $sphere_dots.on('click', function (e) {
      let slug = $(this).attr('data-menu-slug');
      let a = $sphere_panel.find('[data-slug=' + slug + '].link > a');
      if (a.length) a.get(0).click();
    });

    // Menu > buttons interaction
    $sphere_menu_items.on('mouseenter', function (e) {
      let slug = $(this).attr('data-slug');
      $sphere_overlay.find('[data-menu-slug=' + slug + ']').addClass('active');
    });

    $sphere_menu_items.on('mouseleave', function (e) {
      let slug = $(this).attr('data-slug');
      $sphere_overlay.find('[data-menu-slug=' + slug + ']').removeClass('active');
    });

  }

})(jQuery);